export default __webpack_public_path__ + "static/media/Banding.f6d2d7a6.jpeg";